"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[793],{

/***/ 4052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FileIconCsv; },
/* harmony export */   "Dt": function() { return /* binding */ FileIconFasta; },
/* harmony export */   "FE": function() { return /* binding */ FileIconJson; },
/* harmony export */   "GT": function() { return /* binding */ FileIconGff; },
/* harmony export */   "St": function() { return /* binding */ FileIconZip; },
/* harmony export */   "jd": function() { return /* binding */ FileIconNdjson; },
/* harmony export */   "nl": function() { return /* binding */ FileIconTbl; },
/* harmony export */   "yH": function() { return /* binding */ FileIconTsv; },
/* harmony export */   "yZ": function() { return /* binding */ FileIconNwk; }
/* harmony export */ });
/* unused harmony exports DEFAULT_ICON_SIZE, DEFAULT_ICON_COLORS, FileIconContainer, FileIconStyled, FileIconBase */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31382);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37536);
/* harmony import */ var react_file_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47939);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: ",
        "px;\n  height: ",
        ";\n  margin: 3px 15px;\n  filter: drop-shadow(",
        ");\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline;\n  width: ",
        "px;\n  height: ",
        ";\n  max-width: 100%;\n  max-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DEFAULT_ICON_SIZE = 50;
var DEFAULT_ICON_COLORS = {
    fasta: "#66b51d",
    nwk: "#559184",
    csv: "#55aa55",
    tsv: "#7777cc",
    json: "#bb7e38",
    ndjson: "#bb5340",
    gff: "#6b29bb",
    tbl: "#105076",
    zip: "#91640f"
};
var FileIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    componentId: "sc-41291e44-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height && "".concat(height, "px");
}, function(props) {
    return props.theme.shadows.filter.medium;
});
var FileIconStyled = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_file_icon__WEBPACK_IMPORTED_MODULE_3__/* .FileIcon */ .a).withConfig({
    componentId: "sc-41291e44-1"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height && "".concat(height, "px");
});
function FileIconBase(param) {
    var _size = param.size, size = _size === void 0 ? DEFAULT_ICON_SIZE : _size, extension = param.extension, type = param.type, labelColor = param.labelColor, glyphColor = param.glyphColor;
    var ref;
    var styles = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.get)(react_file_icon__WEBPACK_IMPORTED_MODULE_3__/* .defaultStyles */ .j, extension)) !== null && ref !== void 0 ? ref : react_file_icon__WEBPACK_IMPORTED_MODULE_3__/* .defaultStyles.txt */ .j.txt;
    }, [
        extension
    ]);
    var ref1;
    var typeMaybe = (ref1 = type !== null && type !== void 0 ? type : styles === null || styles === void 0 ? void 0 : styles.type) !== null && ref1 !== void 0 ? ref1 : "txt";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconContainer, {
        width: size,
        height: size * 48 / 40,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconStyled, _objectSpread({}, styles, {
            width: size,
            height: size * 48 / 40,
            extension: extension,
            type: typeMaybe,
            radius: 3,
            color: "white",
            labelColor: labelColor,
            glyphColor: glyphColor,
            labelUppercase: true
        }))
    });
}
function FileIconFasta(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "fasta",
        type: "code2",
        labelColor: DEFAULT_ICON_COLORS.fasta,
        glyphColor: DEFAULT_ICON_COLORS.fasta
    });
}
function FileIconNwk(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "nwk",
        type: "document",
        labelColor: DEFAULT_ICON_COLORS.nwk,
        glyphColor: DEFAULT_ICON_COLORS.nwk
    });
}
function FileIconJson(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "json",
        labelColor: DEFAULT_ICON_COLORS.json,
        glyphColor: DEFAULT_ICON_COLORS.json
    });
}
function FileIconNdjson(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "ndjson",
        labelColor: DEFAULT_ICON_COLORS.ndjson,
        glyphColor: DEFAULT_ICON_COLORS.ndjson
    });
}
function FileIconCsv(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "csv",
        labelColor: DEFAULT_ICON_COLORS.csv,
        glyphColor: DEFAULT_ICON_COLORS.csv
    });
}
function FileIconTsv(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "tsv",
        type: "spreadsheet",
        labelColor: DEFAULT_ICON_COLORS.tsv,
        glyphColor: DEFAULT_ICON_COLORS.tsv
    });
}
function FileIconGff(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "gff",
        type: "spreadsheet",
        labelColor: DEFAULT_ICON_COLORS.gff,
        glyphColor: DEFAULT_ICON_COLORS.gff
    });
}
function FileIconTbl(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "tbl",
        type: "spreadsheet",
        labelColor: DEFAULT_ICON_COLORS.tbl,
        glyphColor: DEFAULT_ICON_COLORS.tbl
    });
}
function FileIconZip(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FileIconBase, {
        size: size,
        extension: "zip",
        labelColor: DEFAULT_ICON_COLORS.zip,
        glyphColor: DEFAULT_ICON_COLORS.zip
    });
}


/***/ }),

/***/ 79227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28354);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60822);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21602);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14191);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37536);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25876);
/* harmony import */ var src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87181);
/* harmony import */ var src_hooks_useToggle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83144);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94715);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85983);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 1005;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  overflow-y: auto;\n  box-shadow: 1px 1px 10px 5px #0005;\n  border-radius: 5px;\n  height: 100%;\n  background-color: ",
        ";\n  max-height: 80vh;\n  max-width: 80vw;\n  width: 500px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: ",
        "px;\n  padding: 0 !important;\n  margin: auto 0.5rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 !important;\n  margin: auto !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








function InfoButton(_param) {
    var _size = _param.size, size = _size === void 0 ? 20 : _size, children = _param.children, restProps = _objectWithoutProperties(_param, [
        "size",
        "children"
    ]);
    var t = (0,src_helpers_useTranslationSafe__WEBPACK_IMPORTED_MODULE_2__/* .useTranslationSafe */ ._)().t;
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
    var ref = (0,src_hooks_useToggle__WEBPACK_IMPORTED_MODULE_3__/* .useToggle */ .O)(false), isOpen = ref.state, toggle = ref.toggle, setIsOpen = ref.setState;
    var ref1 = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useFloating */ .YF)({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .shift */ .uY)({
                padding: 5
            }),
            (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .autoPlacement */ .X5)()
        ]
    }), refs = ref1.refs, context = ref1.context, floatingStyles = ref1.floatingStyles;
    var dismiss = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useDismiss */ .bQ)(context);
    var focus = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useFocus */ .KK)(context);
    var role = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useRole */ .qs)(context);
    var ref2 = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useInteractions */ .NI)([
        focus,
        dismiss,
        role
    ]), getReferenceProps = ref2.getReferenceProps, getFloatingProps = ref2.getFloatingProps;
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        toggle();
        e.stopPropagation();
    }, [
        toggle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, _objectSpread({
                innerRef: refs.setReference,
                as: reactstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                title: t("Click to get help information"),
                $size: size
            }, getReferenceProps({
                onClick: onClick
            }), restProps, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    color: theme.primary,
                    size: size * 0.66
                })
            })),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_floating_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .FloatingPortal */ .ll, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Floating, _objectSpread({
                    ref: refs.setFloating,
                    style: floatingStyles
                }, getFloatingProps(), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reactstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: children
                        })
                    })
                }))
            })
        ]
    });
}
var Floating = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e03a6647-0"
})(_templateObject());
var Card = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e03a6647-1"
})(_templateObject1(), function(props) {
    return props.theme.bodyBg;
});
var Button = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-e03a6647-2"
})(_templateObject2(), function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
}, function(props) {
    return props.$size;
});
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_9__/* .FaInfo */ .LL$).withConfig({
    componentId: "sc-e03a6647-3"
})(_templateObject3());


/***/ }),

/***/ 37952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bu": function() { return /* binding */ DatasetInfo; },
  "lF": function() { return /* binding */ datasetColor; },
  "xJ": function() { return /* binding */ formatDatasetInfo; }
});

// UNUSED EXPORTS: DatasetInfoBadges, DatasetInfoLine, DatasetName, DatasetNameHeading, formatReference, formatUpdatedAt

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(28354);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(26417);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(60822);
// EXTERNAL MODULE: ./node_modules/reactstrap/es/Badge.js
var Badge = __webpack_require__(85583);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(37536);
;// CONCATENATED MODULE: ./src/helpers/colorHash.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/* eslint-disable no-param-reassign,no-plusplus,no-loops/no-loops,prefer-destructuring,no-else-return,unicorn/prefer-code-point */ /**
 * Color Hash
 * by Simone Piccian (zanza00)
 * taken with modifications from
 * https://github.com/zanza00/color-hash/blob/6d43fa1b103fa090e1f0d788f5bfc4e99bf02263/src/color-hash.ts
 */ /**
 * BKDR Hash (modified version)
 *
 * @param {String} str string to hash
 * @returns {Number}
 */ function BKDRHash(str) {
    var seed = 131;
    var seed2 = 137;
    var hash = 0;
    // make hash more sensitive for short string like 'a', 'b', 'c'
    str += "x";
    var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER / seed2;
    for(var i = 0; i < str.length; i++){
        if (hash > MAX_SAFE_INTEGER) {
            hash = Math.floor(hash / seed2);
        }
        hash = hash * seed + str.charCodeAt(i);
    }
    return hash;
}
/**
 * Convert RGB Array to HEX
 *
 * @param {Array} RGBArray - [R, G, B]
 * @returns {String} 6 digits hex starting with #
 */ function RGB2HEX(RGBArray) {
    var hex = "#";
    RGBArray.forEach(function(value) {
        if (value < 16) {
            hex += 0;
        }
        hex += value.toString(16);
    });
    return hex;
}
var paramToColor = function(p, q) {
    return function(color) {
        if (color < 0) {
            color++;
        }
        if (color > 1) {
            color--;
        }
        if (color < 1 / 6) {
            color = p + (q - p) * 6 * color;
        } else if (color < 0.5) {
            color = q;
        } else if (color < 2 / 3) {
            color = p + (q - p) * 6 * (2 / 3 - color);
        } else {
            color = p;
        }
        return Math.round(color * 255);
    };
};
/**
 * Convert HSL to RGB
 *
 * @see {@link https://en.wikipedia.org/wiki/HSL_and_HSV} for further information.
 * @param {Number} H Hue ∈ [0, 360)
 * @param {Number} S Saturation ∈ [0, 1]
 * @param {Number} L Lightness ∈ [0, 1]
 * @returns {Array} R, G, B ∈ [0, 255]
 */ function HSL2RGB(H, S, L) {
    var H360 = H / 360;
    var q = L < 0.5 ? L * (1 + S) : L + S - L * S;
    var p = 2 * L - q;
    var partial = paramToColor(p, q);
    return [
        partial(H360 + 1 / 3),
        partial(H360),
        partial(H360 - 1 / 3)
    ];
}

/**
 * Color Hash Class
 *
 * @class
 */ var ColorHash = /*#__PURE__*/ function() {
    "use strict";
    function ColorHash() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, ColorHash);
        var _lightness, _saturation;
        var LS = [
            (_lightness = options.lightness) !== null && _lightness !== void 0 ? _lightness : [
                0.35,
                0.5,
                0.65
            ],
            (_saturation = options.saturation) !== null && _saturation !== void 0 ? _saturation : [
                0.35,
                0.5,
                0.65
            ]
        ].map(function(param) {
            return Array.isArray(param) ? param.concat() : [
                param
            ];
        });
        this.L = LS[0];
        this.S = LS[1];
        if (typeof options.hue === "number") {
            options.hue = {
                min: options.hue,
                max: options.hue
            };
        }
        if (typeof options.hue === "object" && !Array.isArray(options.hue)) {
            options.hue = [
                options.hue
            ];
        }
        if (typeof options.hue === "undefined") {
            options.hue = [];
        }
        this.hueRanges = options.hue.map(function(range) {
            return {
                min: typeof range.min === "undefined" ? 0 : range.min,
                max: typeof range.max === "undefined" ? 360 : range.max
            };
        });
        var _hash;
        this.hash = (_hash = options.hash) !== null && _hash !== void 0 ? _hash : BKDRHash;
    }
    var _proto = ColorHash.prototype;
    _proto.getHue = function getHue(hash) {
        if (this.hueRanges.length > 0) {
            var range = this.hueRanges[hash % this.hueRanges.length];
            var hueResolution = 727 // note that 727 is a prime
            ;
            return hash / this.hueRanges.length % hueResolution * (range.max - range.min) / hueResolution + range.min;
        } else {
            return hash % 359 // note that 359 is a prime
            ;
        }
    };
    /**
   * Returns the hash in [h, s, l].
   * Note that H ∈ [0, 360); S ∈ [0, 1]; L ∈ [0, 1];
   *
   * @param {String} str string to hash
   * @returns {Array} [h, s, l]
   */ _proto.hsl = function hsl(str) {
        var hash = this.hash(str);
        var H = this.getHue(hash);
        var sHash = Math.floor(hash / 360);
        var S = this.S[sHash % this.S.length];
        var lHash = Math.floor(sHash / this.S.length);
        var L = this.L[lHash % this.L.length];
        return [
            H,
            S,
            L
        ];
    };
    /**
   * Returns the hash in [r, g, b].
   * Note that R, G, B ∈ [0, 255]
   *
   * @param {String} str string to hash
   * @returns {Array} [r, g, b]
   */ _proto.rgb = function rgb(str) {
        var hsl = this.hsl(str);
        return HSL2RGB.apply(void 0, _toConsumableArray(hsl));
    };
    /**
   * Returns the hash in hex
   *
   * @param {String} str string to hash
   * @returns {String} hex with #
   */ _proto.hex = function hex(str) {
        var rgb = this.rgb(str);
        return RGB2HEX(rgb);
    };
    return ColorHash;
}();
function colorHash(content, options) {
    var contentModified = content;
    if (options === null || options === void 0 ? void 0 : options.reverse) {
        contentModified = contentModified.split("").reverse().join("");
    }
    if (options === null || options === void 0 ? void 0 : options.prefix) {
        contentModified = "".concat(options.prefix).concat(contentModified);
    }
    if (options === null || options === void 0 ? void 0 : options.suffix) {
        contentModified = "".concat(contentModified).concat(options.suffix);
    }
    return new ColorHash(options).hex(contentModified);
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(31382);
// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(18466);
// EXTERNAL MODULE: ./src/helpers/notUndefined.ts
var notUndefined = __webpack_require__(33887);
;// CONCATENATED MODULE: ./src/helpers/formatDate.ts



function formatDateIsoUtcSimple(dateTimeStr) {
    var utc = luxon/* DateTime.fromISO */.ou.fromISO(dateTimeStr, {
        zone: "UTC"
    });
    var date = utc.toISODate();
    if ((0,lodash.isEmpty)(date)) {
        return undefined;
    }
    var time = utc.toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false
    });
    return [
        date,
        time,
        "(".concat(utc.zoneName, ")")
    ].filter(notUndefined/* notUndefinedOrNull */.$H).filter((0,lodash.negate)(lodash.isEmpty)).join(" ");
}

// EXTERNAL MODULE: ./src/helpers/useTranslationSafe.ts
var useTranslationSafe = __webpack_require__(87181);
// EXTERNAL MODULE: ./src/types.ts
var types = __webpack_require__(27037);
;// CONCATENATED MODULE: ./src/components/Main/DatasetInfo.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 0;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1.2rem;\n  font-weight: bold;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0.9rem;\n  padding: 0;\n  margin: 0;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:after {\n    content: ' ';\n    white-space: pre;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0.7rem;\n  padding: 0.11rem 0.2rem;\n  border-radius: 3px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var DatasetNameHeading = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-a490d9cb-0"
})(_templateObject());
var DatasetName = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(function(param) {
    var color = param.color;
    return {
        style: {
            color: color
        }
    };
}).withConfig({
    componentId: "sc-a490d9cb-1"
})(_templateObject1());
var DatasetInfoLine = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a490d9cb-2"
})(_templateObject2());
function DatasetInfo(_param) {
    var dataset = _param.dataset, restProps = _objectWithoutProperties(_param, [
        "dataset"
    ]);
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    var ref = (0,react.useMemo)(function() {
        return formatDatasetInfo(dataset, t);
    }, [
        dataset,
        t
    ]), datasetName = ref.datasetName, datasetRef = ref.datasetRef, datasetUpdatedAt = ref.datasetUpdatedAt, datasetPath = ref.datasetPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", _objectSpread({
        className: "d-flex flex-column"
    }, restProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DatasetNameHeading, {
                title: datasetName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetName, {
                        children: datasetName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoBadges, {
                        dataset: dataset
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoLine, {
                title: datasetRef,
                children: datasetRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoLine, {
                title: datasetUpdatedAt,
                children: datasetUpdatedAt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoLine, {
                title: datasetPath,
                children: datasetPath
            })
        ]
    }));
}
function formatDatasetInfo(dataset, t) {
    var attributes = dataset.attributes, path = dataset.path, version = dataset.version;
    var ref;
    var datasetName = (ref = (0,types/* attrStrMaybe */.w8)(attributes, "name")) !== null && ref !== void 0 ? ref : path;
    var datasetRef = t("Reference: {{ ref }}", {
        ref: formatReference(attributes)
    });
    var datasetUpdatedAt = t("Updated at: {{updated}}", {
        updated: formatUpdatedAt(version, t)
    });
    var datasetPath = t("Dataset name: {{name}}", {
        name: path
    });
    var color = datasetColor(path);
    return {
        attributes: attributes,
        path: path,
        datasetName: datasetName,
        datasetRef: datasetRef,
        datasetUpdatedAt: datasetUpdatedAt,
        datasetPath: datasetPath,
        color: color
    };
}
function datasetColor(datasetName) {
    return (0,polished_esm/* darken */._j)(0.1)(colorHash(datasetName, {
        lightness: [
            0.35,
            0.5
        ],
        saturation: [
            0.35,
            0.5
        ]
    }));
}
function formatReference(attributes) {
    var ref;
    var name = (ref = (0,types/* attrStrMaybe */.w8)(attributes, "reference name")) !== null && ref !== void 0 ? ref : "unknown";
    var accession = (0,types/* attrStrMaybe */.w8)(attributes, "reference accession");
    if (accession) {
        return "".concat(name, " (").concat(accession, ")");
    }
    return name;
}
function formatUpdatedAt(version, t) {
    var updatedAt = (version === null || version === void 0 ? void 0 : version.updatedAt) ? formatDateIsoUtcSimple(version === null || version === void 0 ? void 0 : version.updatedAt) : t("unknown");
    if ((version === null || version === void 0 ? void 0 : version.tag) === "unreleased") {
        updatedAt = "".concat(updatedAt, " (").concat(t("unreleased"), ")");
    }
    return updatedAt !== null && updatedAt !== void 0 ? updatedAt : t("unknown");
}
function DatasetInfoBadges(param) {
    var _dataset = param.dataset, path = _dataset.path, attributes = _dataset.attributes;
    var t = (0,useTranslationSafe/* useTranslationSafe */._)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "d-flex ml-auto",
        children: [
            path.startsWith("nextstrain") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoBadge, {
                className: "mr-1 my-0",
                color: "success",
                title: t("This dataset is provided by {{proj}} developers.", {
                    proj: "Nextclade"
                }),
                children: t("official")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoBadge, {
                className: "mr-1 my-0",
                color: "info",
                title: t("This dataset is provided by the community members. {{proj}} developers cannot verify correctness of community datasets or provide support for them. Use at own risk. Please contact dataset authors for all questions.", {
                    proj: "Nextclade"
                }),
                children: t("community")
            }),
            (0,types/* attrBoolMaybe */.x9)(attributes, "experimental") && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoBadge, {
                className: "mr-1 my-0",
                color: "warning",
                title: t("Dataset authors marked this dataset as experimental, which means the dataset is still under development, is of lower quality than usual or has other issues. Use at own risk. Please contact dataset authors for specifics."),
                children: t("experimental")
            }),
            (0,types/* attrBoolMaybe */.x9)(attributes, "deprecated") && /*#__PURE__*/ (0,jsx_runtime.jsx)(DatasetInfoBadge, {
                className: "mr-1 my-0",
                color: "secondary",
                title: t("Dataset authors marked this dataset as deprecated, which means the dataset is obsolete, will no longer be updated or is not relevant otherwise. Please contact dataset authors for specifics."),
                children: t("deprecated")
            })
        ]
    });
}
var DatasetInfoBadge = (0,styled_components_browser_esm/* default */.ZP)(Badge/* default */.Z).withConfig({
    componentId: "sc-a490d9cb-3"
})(_templateObject3());


/***/ })

}]);